<template>
  <aside>
    <DxList
      :data-source="notifications"
      displayExpr="message"
      :no-data-text="'No data'"
      height="300px"
      class="notifications-list"
    >
      <template #itemTemplate="{ data }">
        <div class="notification-item row">
          <div class="column justify-center">
            <div v-if="!data.isSeen" class="blue-dot"></div>
          </div>

          <div class="column main-col">
            <span class="notification-message">
              {{ moment(data.createdDate).format("DD-MM-YYYY") }}
            </span>
            <span
              class="notification-message"
              @click="markNotificationAsSeen(data)"
            >
              {{ data.message }} </span
            ><span class="notificaiton-message" style="padding-left: 8px">
              <router-link
                v-if="data.schemeId"
                class="edit-link"
                :to="{
                  name: 'EditScheme',
                  params: { id: data.schemeId }
                }"
                v-bind:target="'_blank'"
                style="text-decoration: underline; cursor: default"
              >
                {{ `Click this link to view the ${entityLabel}.` }}
              </router-link>

              <a
                v-if="data.url"
                class="edit-link"
                :href="data.url"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="View the call on the EU Portal (opens in a new tab)"
                style="text-decoration: underline; padding-left: 8px"
              >
                {{ "View the call on the EU Portal." }}
              </a>
            </span>
          </div>

          <div v-if="data.isSeen" class="column justify-center delete-col">
            <i
              class="las la-2x la-trash edit-remark-icon"
              role="button"
              tabindex="0"
              aria-label="Delete notification"
              @click.stop="deleteNotificationById(data.id)"
              @keydown.enter.stop.prevent="deleteNotificationById(data.id)"
              @keydown.space.stop.prevent="deleteNotificationById(data.id)"
            ></i>
          </div>
        </div>
      </template>
    </DxList>
  </aside>
</template>

<script setup>
import { computed, defineProps } from "vue";
import moment from "moment";
import { DxList } from "devextreme-vue/list";

const props = defineProps({
  data: {
    type: Array,
    required: true,
    default: () => []
  },
  markNotificationAsSeen: {
    type: Function,
    required: true
  },
  deleteNotification: {
    type: Function,
    required: true
  },
  entityLabel: {
    type: String,
    default: "scheme"
  }
});

const notifications = computed(() => props.data);

const markNotificationAsSeen = data => {
  if (!data.isSeen) {
    props.markNotificationAsSeen(data.id);
  }
};

const deleteNotificationById = async id => {
  props.deleteNotification(id);
};
</script>

<style lang="scss" scoped>
.blue-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #25408f;
  align-self: center;
}

.notification-item {
  display: flex;
}

.notification-message {
  padding-left: 8px !important;
  max-width: 100% !important;
  white-space: initial !important;
}

.notifications-list {
  /* Matches the tab strip width so the panel stays compact and the list
     content fills it edge-to-edge. */
  width: 560px !important;
}

.main-col {
  flex: 1;
  min-width: 0;
}

.delete-col {
  /* main-col's flex:1 pushes this to the right edge, away from the text */
  margin-left: 8px;
}

.delete-col .edit-remark-icon {
  /* Guarantees a 24x24 pointer target (WCAG 2.2 - 2.5.8) around the glyph. */
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
}
</style>
